import AddIcon from 'assets/ver2/icons/add-outline-green-icon-2.svg';
import { InstructionBodyContent } from 'components/FormAddTransaction/components/PaymentMethodsGrid/PaymentMethodItem/ver2';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import SizeBox from 'components/common/SizeBox';
import {
  FUNC_DEFAULT,
  FX_EMAIL,
  FX_PHONE,
  HHMT_EMAIL,
  HHMT_PHONE,
  REMOX_EMAIL,
  REMOX_PHONE,
} from 'constants';
import { QuestionIcon } from 'constants/icon';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import usePortalModal from 'hooks/usePortalModal';
import useTheme from 'hooks/useTheme';
import { isArray, isEmpty } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import {
  displayFlexColCenterCenterMixin,
  displayFlexRowCenterCenterMixin,
  fontSize14Mixin,
  paragraph500Mixin,
  paragraph600Mixin,
} from 'styles';

const PaytoBodyContent = ({
  onClick = FUNC_DEFAULT,
  renderBodyContentCommon = () => null,
  handleShowPaymentInstructionModal,
  isPayLimit,
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();
  const { isAddTransactionPage } = usePage();

  const { paytoAccountsAgreement } = usePaytoStore();
  const { showPortalModalName } = usePortalModal();

  const isDisabled =
    isArray(paytoAccountsAgreement) &&
    paytoAccountsAgreement?.some(
      (accountAgreement) => accountAgreement?.blocked
    );

  const handleOnClick = (e) => {
    if (!isEmpty(paytoAccountsAgreement)) return;
    e.preventDefault();
    onClick();
  };

  const handleShowDetailsModal = () => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.PAYMENT_INSTRUCTION_MODAL,
      content: (
        <InstructionBodyContent
          dangerouslySetInnerHTML={{
            __html: t('popup_payto_disabled_details_desc', {
              email: isAddTransactionPage
                ? isHHMTTheme
                  ? HHMT_EMAIL
                  : REMOX_EMAIL
                : FX_EMAIL,
              phone: isAddTransactionPage
                ? isHHMTTheme
                  ? HHMT_PHONE
                  : REMOX_PHONE
                : FX_PHONE,
            }),
          }}
        />
      ),
    });
  };

  if (isDisabled)
    return (
      <>
        <>{renderBodyContentCommon()}</>
        <p
          className="image-desc"
          style={{ textAlign: 'center', color: 'var(--ds-c-red)' }}
        >
          {`${t('label_payto_method_temporarily_blocked')}`}
        </p>
        <p
          className="image-sub-desc payto-disable-details"
          style={{
            textAlign: 'center',
            color: '#7A8189',
            textDecoration: 'underline',
          }}
          onClick={handleShowDetailsModal}
        >
          {`${t('label_details')}`}
        </p>
        {handleShowPaymentInstructionModal && (
          <InstructionImage
            className="question-icon"
            src={QuestionIcon}
            width={20}
            height={20}
            onClick={handleShowPaymentInstructionModal}
          />
        )}
      </>
    );
  if (!isEmpty(paytoAccountsAgreement)) return <>{renderBodyContentCommon()}</>;
  if (isPayLimit) return <>{renderBodyContentCommon()}</>;
  return (
    <>
      <PaytoBodyContentMask onClick={handleOnClick} />
      <PaytoBodyContentStyled>
        <ActionLabel>{t('label_payto')}</ActionLabel>
        <SizeBox height={4} />
        <ActionTextIcon>
          <ActionText>{t('label_set_up_agreement')}</ActionText>
          <ActionIcon src={AddIcon} width={24} height={24} />
        </ActionTextIcon>
      </PaytoBodyContentStyled>
    </>
  );
};

const PaytoBodyContentMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: transparent;
  width: 100%;
  height: 100%;
`;

const PaytoBodyContentStyled = styled.div`
  ${displayFlexColCenterCenterMixin};
`;

const ActionLabel = styled.p`
  ${paragraph600Mixin};
`;
const ActionIcon = styled.img`
  width: 24px !important;
  height: 24px !important;
  object-fit: contain !important;
  margin: 0 !important;
`;
const ActionText = styled.p`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
`;

const ActionTextIcon = styled.div`
  ${displayFlexRowCenterCenterMixin};
  gap: 4px;
`;

const InstructionImage = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 40px !important;
  height: 40px !important;
  margin: 0 !important;
  padding: 10px;
  filter: var(--ds-f-c-blue-hyperlink) !important;
`;

export default PaytoBodyContent;
